import { Button, ButtonSize, EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';
import { useEffect } from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { post } from '../../../ReactComponents/API';
import { Modal, ModalButtons, ModalText } from '../../../ReactComponents/Modal/Modal';

export const showCartMergedModal = (hasRemovedRxItems: boolean) => {
    const event = new CustomEvent(EventNames.CartMerged, {
        detail: { hasRemovedRxItems: hasRemovedRxItems }
    });
    window.dispatchEvent(event);
};

export interface CartMergedModalProps {
    acknowledgeMergeUrl: string;
}

export const CartMergedModal = (props: CartMergedModalProps) => {
    const [isVisible, setIsVisible] = React.useState(false);
    const [hasRemovedRxs, setHasRemovedRxs] = React.useState(false);

    const showModal = ($event: CustomEventInit) => {
        if ($event && $event.detail) {
            const hasRemovedRxItems = $event.detail.hasRemovedRxItems;

            if (hasRemovedRxItems) {
                setHasRemovedRxs(true);
            }
        }

        setIsVisible(true);
    };

    const handleClose = () => {
        post(props.acknowledgeMergeUrl).finally(() => {
            setIsVisible(false);
        });
    };

    useEffect(() => {
        window.addEventListener(EventNames.CartMerged, showModal);

        return () => {
            window.removeEventListener(EventNames.CartMerged, showModal);
        };
    });

    const buildMessage = () => {
        let message = getTranslation(keys['cartSummary.merged']);
        if (hasRemovedRxs) {
            message += ' ' + getTranslation(keys['modal.rxSession.expiredBody']);
        }

        return message;
    };

    return (
        <Modal open={isVisible} onClose={handleClose}>
            <ModalText>{buildMessage()}</ModalText>
            <ModalButtons>
                <Button size={ButtonSize.Medium} onClick={handleClose}>
                    {getTranslation(keys['navigation.close'])}
                </Button>
            </ModalButtons>
        </Modal>
    );
};
